import { render, staticRenderFns } from "./aggregated-row.vue?vue&type=template&id=581965b8&scoped=true&"
import script from "./aggregated-row.vue?vue&type=script&lang=ts&"
export * from "./aggregated-row.vue?vue&type=script&lang=ts&"
import style0 from "./aggregated-row.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./aggregated-row.vue?vue&type=style&index=1&id=581965b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581965b8",
  null
  
)

export default component.exports